import { render, staticRenderFns } from "./CurrencyIcon.vue?vue&type=template&id=f3ed4acc&scoped=true"
import script from "./CurrencyIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrencyIcon.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CurrencyIcon.vue?vue&type=style&index=0&id=f3ed4acc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ed4acc",
  null
  
)

export default component.exports